import React from 'react';
import cx from 'classnames';
import { Profile } from '~/types/models';

interface SearchResultRowProps {
  selected: boolean;
  contact: Profile;
  onContactSelected: (contact: Profile) => void;
}

export default function SearchResultRow({
  contact,
  selected,
  onContactSelected,
}: SearchResultRowProps) {
  return (
    <div
      className={cx(
        [
          'h-14 pr-7 py-2.5 flex items-center hover:bg-turquoise-100 focus:bg-black',
        ],
        { 'bg-turquoise-100': selected }
      )}
      onClick={() => {
        onContactSelected(contact);
      }}
    >
      <div className={cx('w-1 h-14', { 'bg-turquoise': selected })} />
      <input type='radio' className='hidden' checked={selected} />
      <img src={contact.image} className='ml-4 w-10 h-10 rounded-lg'></img>
      <div className='h-10 flex items-center'>
        <span className='pl-7 w-30 font-bold truncate'>{contact.name}</span>
        <span className='ml-7 w-48 truncate'>{contact.email}</span>
      </div>
    </div>
  );
}
